<template>
	<template v-if="!isFromAgenda && !isOpenVoiceWindow">
		<div class="main-report tbl-list agenda_info_area agenda_under_line">
			<h4>
				<span class="icon icon-up" v-b-toggle="'speechtotext_div'" aria-expanded="true" role="button"
					id="speechtotext_div-target"></span>音声補助
					 <!-- <input type="button" value="1行作るよ" id="dummy" style="background: blue;color:white;margin-left:20px;">
					 <input type="button" value="10行作るよ" id="dummy2" style="background: blue;color:white;margin-left:20px;">
					 <input type="button" value="50行つくるよ（激重）" id="dummy4" style="background: blue;color:white;margin-left:20px;"> -->

			</h4>
			<b-collapse id="speechtotext_div" visible>
				<div class="collapse show content-box dept-theme">
					<div class="agenda-main-box" style="padding-left: initial;">
						<div class="dept-theme-request agenda_detail_block">
							<div class="theme_head_title d-flex align-items-center">
								<i class="bi bi-circle-fill mr-1"></i>音声文字起こし
								<input type="checkbox" name="check" id="playbutton" style="display: none;" />
								<label for="playbutton" class="label ml-2">
									<img class="img-mikeon" src="~@/assets/img/mike_on.png" width="30" height="30" alt="" style="display: none;">
									<img class="img-mikeoff" src="~@/assets/img/mike_off.png" width="30" height="30" alt="">
								</label>
								<div id="mikeAllOff" class="btn btn-sm rounded-pill ml-2" rel="noopener noreferrer" style="background: #57a2f4; color: white; cursor: pointer;">
										全員のマイクをオフにする
								</div>
								<div class="ml-auto">
									<input type="button" id="open_voice_window" style="display: none;" />
									<label class="label" for="open_voice_window">
										<img class="img-openwindow" src="~@/assets/img/open_window.png" width="25" height="25" alt="">
									</label>
								</div>
							</div>
							<div class="base_minutes">
								<div class="bg-white border-dark" style="padding:5px">
									<template v-for="talk in outputlist" :key="talk.id">
										<span class=" my-1 align-items-start speechtext" :id="talk.id" v-bind:class="{ hiddenRow: talk.delete, 'd-flex': !talk.delete}">
											<template v-if="isDisplayPlaying">
											<button class="audioplay userDate" :user="talk.userid" :startDt="talk.startDate">
												<img class="img-play" src="~@/assets/img/start_icon.png" width="20" height="20" alt="">
												<img class="img-stop" src="~@/assets/img/stop_icon.png" width="20" height="20" alt="" style="display: none;">
											</button>
											</template>
											<template v-else>
												<img class="img-noplay userDate" src="~@/assets/img/nostart_icon.png" width="20" height="20" alt="" :user="talk.userid" :startDt="talk.startDate">
											</template>
											<p class="ml-2 text-nowrap text2margin" :user="talk.userid">{{this.getSystemDateFormat(talk.startDate)}}</p>
											<p class="ml-3 text2margin namearea" :name="talk.username" style="width: 88px;min-width:88px;max-width: 88px;">{{talk.username}}</p>
											<p class="text2margin">:</p>
											<div class="deleteHover" style="display: flex;">
												<p class="ml-2 textcopy text2margin">{{talk.talkval}}</p>
												<button class="textdelete"><img class="img-delete-text" src="~@/assets/img/img-delete-text.png" width="20" height="20" alt=""></button>
											</div>
										</span>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
			<div class="row mt-3 ">
				<div class="col-7">
					<div id="sound-clips">
					</div>
				</div>
			</div>
		</div>
	</template>
	
	<template v-if="isOpenVoiceWindow">
		<b-collapse id="speechtotext_div" visible>
			<div class="collapse show content-box dept-theme">
				<div class="agenda-main-box" style="padding-left: initial;">
					<div class="dept-theme-request agenda_detail_block">
						<div class="theme_head_title d-flex align-items-center">
							<i class="bi bi-circle-fill mr-1"></i>音声文字起こし
							<input type="checkbox" name="check" id="playbutton" style="display: none;" />
							<label for="playbutton" class="label ml-2">
								<img class="img-mikeon" src="~@/assets/img/mike_on.png" width="30" height="30" alt="" style="display: none;">
								<img class="img-mikeoff" src="~@/assets/img/mike_off.png" width="30" height="30" alt="">
							</label>
						</div>
						<div class="base_minutes">
							<div class="bg-white border-dark" style="padding:5px">
								<template v-for="talk in outputlist" :key="talk.id">
									<span class=" my-1 align-items-start speechtext" :id="talk.id" v-bind:class="{ hiddenRow: talk.delete, 'd-flex': !talk.delete}">
										<template v-if="isDisplayPlaying">
										<button class="audioplay userDate" :user="talk.userid" :startDt="talk.startDate">
											<img class="img-play" src="~@/assets/img/start_icon.png" width="20" height="20" alt="">
											<img class="img-stop" src="~@/assets/img/stop_icon.png" width="20" height="20" alt="" style="display: none;">
										</button>
										</template>
										<template v-else>
											<img class="img-noplay userDate" src="~@/assets/img/nostart_icon.png" width="20" height="20" alt="" :user="talk.userid" :startDt="talk.startDate">
										</template>
										<p class="ml-2 text-nowrap text2margin" :user="talk.userid">{{this.getSystemDateFormat(talk.startDate)}}</p>
										<p class="ml-3 text2margin namearea" :name="talk.username" style="width: 88px;min-width:88px;max-width: 88px;">{{talk.username}}</p>
										<p class="text2margin">:</p>
										<div class="deleteHover" style="display: flex;">
											<p class="ml-2 textcopy text2margin">{{talk.talkval}}</p>
											<button class="textdelete"><img class="img-delete-text" src="~@/assets/img/img-delete-text.png" width="20" height="20" alt=""></button>
										</div>
									</span>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-collapse>
		<div class="row mt-3 ">
			<div class="col-7">
				<div id="sound-clips">
				</div>
			</div>
		</div>
	</template>
	
	<template v-if="isFromAgenda">
		<input type="checkbox" name="check" id="playbutton" style="display: none;" />
		<div class="mt-5 d-flex justify-content-center">
			<label for="playbutton" class="label">
				<img class="img-mikeon" src="~@/assets/img/mike_on.png" width="150" height="150" alt="" style="display: none;">
				<img class="img-mikeoff" src="~@/assets/img/mike_off.png" width="150" height="150" alt="">
			</label>
		</div>
		<div class="mt-5 d-flex justify-content-center">
			<a id="leave" href="" class="btn btn-primary text-center px-4 py-2" style="font-size: large;">退&emsp;出</a>
		</div>
		<div class="base_minutes" style="display: none;">
			<!-- <div class="base_minutes"> -->
			<div class="bg-white border-dark" style="padding:5px">
				<template v-for="talk in outputlist" :key="talk.id">
					<span class=" my-1 align-items-start speechtext" :id="talk.id" v-bind:class="{ hiddenRow: talk.delete, 'd-flex': !talk.delete}">
						<template v-if="isDisplayPlaying">
						<button class="audioplay userDate" :user="talk.userid" :startDt="talk.startDate">
							<img class="img-play" src="~@/assets/img/start_icon.png" width="20" height="20" alt="">
							<img class="img-stop" src="~@/assets/img/stop_icon.png" width="20" height="20" alt="" style="display: none;">
						</button>
						</template>
						<template v-else>
							<img class="img-noplay userDate" src="~@/assets/img/nostart_icon.png" width="20" height="20" alt="" :user="talk.userid" :startDt="talk.startDate">
						</template>
						<p class="ml-2 text-nowrap text2margin" :user="talk.userid">{{this.getSystemDateFormat(talk.startDate)}}</p>
						<p class="ml-3 text2margin namearea" :name="talk.username" style="width: 88px;min-width:88px;max-width: 88px;">{{talk.username}}</p>
						<p class="text2margin">:</p>
						<div class="deleteHover" style="display: flex;">
							<p class="ml-2 textcopy text2margin">{{talk.talkval}}</p>
							<button class="textdelete"><img class="img-delete-text" src="~@/assets/img/img-delete-text.png" width="20" height="20" alt=""></button>
						</div>
					</span>
				</template>
			</div>
		</div>
	</template>

	<CopyTextModal />

	<div class="sk-fading-circle hide" style="display:none;">
			<div class="sk-circle1 sk-circle"></div>
			<div class="sk-circle2 sk-circle"></div>
			<div class="sk-circle3 sk-circle"></div>
			<div class="sk-circle4 sk-circle"></div>
			<div class="sk-circle5 sk-circle"></div>
			<div class="sk-circle6 sk-circle"></div>
			<div class="sk-circle7 sk-circle"></div>
			<div class="sk-circle8 sk-circle"></div>
			<div class="sk-circle9 sk-circle"></div>
			<div class="sk-circle10 sk-circle"></div>
			<div class="sk-circle11 sk-circle"></div>
			<div class="sk-circle12 sk-circle"></div>
	</div>
</template>


<script>

	import {nanoid} from 'nanoid'
	import $ from "jquery";
	import config from "@/config";
	import { isOn } from '@vue/shared';
	import * as fflate from 'fflate';


	export default {
		props: {
			sync: Object,
			userid: String,
			username: String,
			isFromAgenda: Object,
			csfr: Object,
			agenda_id: Object,
			version: Object,
			version_name: Object,
			url: Object,
			isOpenVoiceWindow : Object,
			initSpeech: Object,
		},
		data: () => ({
			talklist: {},
			outputlist: [],
			initialize: true,
			isEnabledMikeList: {},
			isDisplayPlaying: false,
			isSpeechUpdate: false,
			mediaRecorder : null,
			mediaRecorderFlag:true,
			startdate:null,
			startmilli:null,
			chunks:[]
		}),
		watch: {
			talklist: function (newval, oldval) {
				let _self = this;

				if (!_self.initialize) {
					return;
				}

				var rep = false;
			},
		},
		async created() {

			let _self = this;

			this.sync.observe((event) => {
				if (event.keysChanged.has("diff")) {

					if (!_self.initialize) {
						var tmpdata = _self.sync.get("diff");
						const decompressed = fflate.decompressSync(tmpdata);
						const origText = fflate.strFromU8(decompressed);
						var talk = JSON.parse(origText);

						if (talk && talk.length > 0) {
							var user = talk[0]["username"];
							_self.talklist[user] = talk;
							const buf = fflate.strToU8(JSON.stringify(_self.talklist));
							const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
							_self.sync.set("talklist", compressed);		
						} 
						_self.doSetOutputlist();
					}
				}

				if(event.keysChanged.has("isEnabledMikeList")) {
					var tempEnabledMikeList = _self.sync.get("isEnabledMikeList");

					if (_self.isEnabledMikeList[_self.userid] != undefined && _self.isEnabledMikeList[_self.userid]["isMike"] != undefined) {
						var nowMyStatus = _self.isEnabledMikeList[_self.userid].isMike;
						
						if (!nowMyStatus) {
							for (let i in tempEnabledMikeList) {
								if (_self.userid == i && tempEnabledMikeList[i].isMike) {
									$("#playbutton").trigger('click', false);
								}
							}
						}
					}

					_self.isEnabledMikeList = _self.sync.get("isEnabledMikeList");
					_self.$emit('getMike', _self.isEnabledMikeList);

				}

				if (event.keysChanged.has("isUpdate")) {
					_self.isSpeechUpdate = _self.sync.get("isUpdate");
				}
			});
		},

		methods: {
			async playButtonEnd(isInsert) {
				var _self = this;
				if ($("#playbutton").prop('checked')){
					if(this.mediaRecorder) {
						
						const enddate = new Date();
						var endmilli = enddate.getMilliseconds();

						const blob = new Blob(_self.chunks, {type: "audio/ogg; codecs=opus"});
						_self.chunks = [];

						if (isInsert) {
							await _self.insertSpeechData(blob, _self.startdate, enddate, _self.startmilli, endmilli);
							await this.mediaRecorder.stop();

							this.mediaRecorderFlag = false;
							await $("#playbutton").trigger('click', true);
						}
						else {
							await this.mediaRecorder.stop();
							this.mediaRecorderFlag = false;
							await $("#playbutton").trigger('click', true);
							var returnParam =  {file:blob, agenda_id: _self.agenda_id, startdate:_self.startdate, enddate:enddate, startmilli:_self.startmilli, endmilli: endmilli};
							return returnParam;
						}
						// await this.mediaRecorder.stop();

						// this.mediaRecorderFlag = false;
						// await $("#playbutton").trigger('click', true);
					}
				}
			},
			getOnseiUpdate() {
				var _self = this;
				return _self.isSpeechUpdate;
			},
			initPage() {

				var _self = this;
				var $gijiroku = $("#gijiroku_henshu_user img");
					setTimeout(async function () {

						if($gijiroku.length == 1 && $gijiroku.attr("userid") == _self.userid) {
							_self.talklist = _self.initSpeech
						} else {
							var talklist = {};
							var tmpdata = await _self.sync.get("talklist");
							if (tmpdata != undefined) {
								const decompressed = fflate.decompressSync(tmpdata);
								const origText = fflate.strFromU8(decompressed);

								if (origText == "{}") {
									_self.talklist = _self.initSpeech;
								} else {
									talklist = JSON.parse(origText);
									_self.talklist = talklist || _self.initSpeech;
								}
							} else {
								_self.talklist = _self.initSpeech;
							}
						}

						if (!_self.talklist[_self.username]) {
							_self.talklist[_self.username] = [];
						}
						if (_self.talklist[_self.username] && _self.talklist[_self.username].length > 0) {
							var target = _self.talklist[_self.username].filter(function (item) {
								return item.username == _self.username
							}, this)

							for (var i = 0; i < target.length; i++) {
								target[i]["isFinal"] = true;
							}
						}
						_self.initialize = false;

						_self.doSetOutputlist();
						
						// const buf = fflate.strToU8(JSON.stringify(_self.talklist));
						// const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });

					}, 1500);

					// setTimeout(async function () {
					var isEnabledMikeList = _self.sync.get("isEnabledMikeList")
					_self.isEnabledMikeList = isEnabledMikeList || {}
					_self.$emit('getMike', _self.isEnabledMikeList);
					// }, 100);
				// }

				if (!_self.isFromAgenda) {

					const parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ? config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
					var count = 0;
					var returnData = null;
					var countData = {
						agenda_id: _self.agenda_id,
					}
					var deferred = new $.Deferred();
					var jqXHR = $.ajax({
						type: 'post',                // method = "POST"
						url: parenturl + 'countSpeechFile',        // POST送信先のURL
						data: JSON.stringify(countData),  // JSONデータ本体
						contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
						dataType: 'json',           // レスポンスをJSONとしてパースする
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						headers: {
							'X-CSRF-TOKEN': _self.csfr,
						},
					}).done(function (obj) {
						if (obj.count.length > 0) {
							count = obj.count.length;
							returnData = obj.count;
						}
					}).always(function () {
						deferred.resolve();
					});

					deferred.done(function () {

						if (returnData != null && returnData[0] != null) {
							var doukiNum = 0;
							for (let i = 0; i < count; i++) {
								let url = parenturl + "fileupload/downloadSpeechFile" // action属性のurlを抽出
								let data = "agenda_id=" + encodeURIComponent(_self.agenda_id) + "&file_name=" + encodeURIComponent(returnData[i]["FILE_NAME"]);
								let httpRequest = new XMLHttpRequest();  // XMLHttpRequestのインスタンス作成
								httpRequest.open("POST", url, true);  // open(HTTPメソッド, URL, 非同期通信[true:default]か同期通信[false]か）
								httpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");  // リクエストヘッダーを追加(URIエンコードで送信)
								httpRequest.setRequestHeader("X-CSRF-TOKEN", _self.csfr);  // リクエストヘッダーを追加(URIエンコードで送信)
								httpRequest.responseType = "blob";
								httpRequest.withCredentials = true;
								httpRequest.send(data);  // sendメソッドでサーバに送信

								httpRequest.onreadystatechange = function () {
									if (httpRequest.readyState === 4) {  // readyStateが4になればデータの読込み完了
										doukiNum = doukiNum + 1;
										if (httpRequest.status === 200) {  // statusが200の場合はリクエストが成功

											if (httpRequest.response.size != 0) {
												const soundClips = $("#sound-clips");
												let audio = $("<audio hidden>").attr("controls", "").attr("id", returnData[i]["FILE_ID"]);
												// let audio = $("<audio>").attr("controls", "").attr("id", returnData[i]["FILE_ID"]);
												audio.addClass("audioList");
                       							audio.attr("speaker", returnData[i]["SPEAKER"]);
												audio.attr("startDate", new Date(new Date(returnData[i]["START_TIME"]).getTime()+ ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000)));
												audio.attr("endDate", new Date(new Date(returnData[i]["END_TIME"]).getTime()+ ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000)));
												soundClips.append(audio);

												const audioURL = window.URL.createObjectURL(httpRequest.response);
												audio.attr("src", audioURL);
																
												if (doukiNum==count) {
													_self.isDisplayPlaying = true;
												}
											}

										} else {  // statusが200以外の場合はリクエストが適切でなかったとしてエラー表示
										}
									}
								};
							}
						} else {
							// ここで取れていない場合の非活性をする。
							_self.isDisplayPlaying = false;
						};
					});

				} else {
					let defaultStyle = $("#playbutton").closest(".main" + ".header_row").attr("style");
					if(defaultStyle == undefined) {
						defaultStyle = "";
					}
					$("#playbutton").closest(".main" + ".header_row").css("cssText", defaultStyle + "height:100% !important");
				}
				if (!_self.isOpenVoiceWindow) {
					for (let i in _self.isEnabledMikeList) {
						if (_self.userid == i && !_self.isEnabledMikeList[i]["isMike"]) {
							if (typeof(_self.isEnabledMikeList[i]["isMike"]) == "boolean") {
								_self.isEnabledMikeList[i] = {};
							}
							_self.isEnabledMikeList[i]["username"] = _self.username;
							_self.isEnabledMikeList[i]["isMike"] = true;

							_self.sync.set("isEnabledMikeList", _self.isEnabledMikeList);
						}
					}
				}

			},
			async replaceNullData() {

				var _self = this;

				var $gijiroku = $("#gijiroku_henshu_user img");
				if(!$gijiroku.length) {
					
					const buf = fflate.strToU8(JSON.stringify({}));
					const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
					
					await this.sync.set("talklist", compressed);
					//_self.doSetOutputlist();
				} else {
					if($gijiroku.length == 1 && $gijiroku.attr("userid") == this.userid) {
						
						const buf = fflate.strToU8(JSON.stringify({}));
						const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
												
						await this.sync.set("talklist", compressed);
						//_self.doSetOutputlist();
					}
				}
			},

			doSetOutputlist() {

				let dummy = [];
				for (let o in this.talklist) {
					for (let p in this.talklist[o]) {
						dummy.push(this.talklist[o][p])
					}
				}
				// 昇順
				dummy.sort(function (a, b) {
					return (new Date(a.startDate) > new Date(b.startDate) ? 1 : -1);
				});

				this.outputlist = dummy;

			},
			addListRow(usertalklist, isFinalFlag = false) {

				if (isFinalFlag) {
					var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === this.username && !isFinal)

					if (lastIndex != -1) {
						usertalklist[lastIndex]["isFinal"] = true;
					}
				} else {
					usertalklist.push({userid: this.userid, username: this.username, talkval: "", isFinal: false, startDate: this.getSystemDate(), id:nanoid(32)});
				}
			},
			replaceLastRowData(senddata = {}) {

				if (!this.isSpeechUpdate) {
					this.isSpeechUpdate = true;
					this.sync.set("isUpdate", this.isSpeechUpdate);
				}

				var usertalklist = this.talklist[this.username];

				if (senddata.isFinal) {
					this.addListRow(usertalklist, senddata.isFinal);
				}

				if (senddata.talklist_val != "") {
					var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === this.username && !isFinal)
					if (lastIndex == -1) {
						this.addListRow(usertalklist);
					}
					var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === this.username && !isFinal)
					usertalklist[lastIndex]["talkval"] = senddata.talklist_val;
					usertalklist.splice();

				}

				this.talklist[this.username] = usertalklist;
				const buf = fflate.strToU8(JSON.stringify(usertalklist));
				const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
				this.sync.set("diff", compressed);
				this.doSetOutputlist();

			},
			doDeleteList (speechId, username) {

				if (!this.isSpeechUpdate) {
					this.isSpeechUpdate = true;
					this.sync.set("isUpdate", this.isSpeechUpdate);
				}

				var usertalklist = this.talklist[username];

				var index = usertalklist.findLastIndex(({id}) => id === speechId);
				if (index != -1) {
					usertalklist[index]["delete"] = true;
				}

				this.talklist[username] = usertalklist;
				const buf = fflate.strToU8(JSON.stringify(usertalklist));
				const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
				this.sync.set("diff", compressed);
				this.doSetOutputlist();

			},
			getSystemDate() {
				// var dateObj = new Date().toLocaleString({ timeZone: 'Asia/Tokyo' }),
				var dateObj = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000)),
					dateYear = dateObj.getFullYear(),
					dateMonth = dateObj.getMonth() + 1,
					dateDay = dateObj.getDate(),
					dateWeek = dateObj.getDay(),
					timeHour = dateObj.getHours(),
					timeMinutes = dateObj.getMinutes(),
					timeSeconds = dateObj.getSeconds(),
					timeMilli = dateObj.getMilliseconds(),
					weekNames = ['日', '月', '火', '水', '木', '金', '土'],
					result = '';

				// 一桁の場合は0を追加
				if (timeHour < 10) timeHour = '0' + timeHour;
				if (timeMinutes < 10) timeMinutes = '0' + timeMinutes;
				if (timeSeconds < 10) timeSeconds = '0' + timeSeconds;

				// 文字列の結合
				result = dateYear + '/' + dateMonth + '/' + dateDay + ' ';
				result += timeHour + ':' + timeMinutes + ':' + timeSeconds + "." + timeMilli;

				return result;
			},
			getSystemDateFormat(dateObj) {
				dateObj = dateObj.replaceAll("/","-");
				
				var dateObj = new Date(dateObj),
					dateYear = dateObj.getFullYear(),
					dateMonth = dateObj.getMonth() + 1,
					dateDay = dateObj.getDate(),
					dateWeek = dateObj.getDay(),
					timeHour = dateObj.getHours(),
					timeMinutes = dateObj.getMinutes(),
					timeSeconds = dateObj.getSeconds(),
					weekNames = ['日', '月', '火', '水', '木', '金', '土'],
					result = '';

				// if (value != null) {
				// 	dateObj = new Date(value)
				// }

				// 一桁の場合は0を追加
				if (dateMonth < 10) dateMonth = '0' + dateMonth;
				if (dateDay < 10) dateDay = '0' + dateDay;
				if (timeHour < 10) timeHour = '0' + timeHour;
				if (timeMinutes < 10) timeMinutes = '0' + timeMinutes;
				if (timeSeconds < 10) timeSeconds = '0' + timeSeconds;

				// 文字列の結合
				result = timeHour + ':' + timeMinutes + ':' + timeSeconds;
				return result;
			},
			getSystemDateFormat2(dateObj) {
				dateObj = dateObj.replaceAll("/","-");
				
				var dateObj = new Date(dateObj),
					dateYear = dateObj.getFullYear(),
					dateMonth = dateObj.getMonth() + 1,
					dateDay = dateObj.getDate(),
					dateWeek = dateObj.getDay(),
					timeHour = dateObj.getHours(),
					timeMinutes = dateObj.getMinutes(),
					timeSeconds = dateObj.getSeconds(),
					timeMilli = dateObj.getMilliseconds(),
					weekNames = ['日', '月', '火', '水', '木', '金', '土'],
					result = '';

				// if (value != null) {
				// 	dateObj = new Date(value)
				// }

				// 一桁の場合は0を追加
				if (dateMonth < 10) dateMonth = '0' + dateMonth;
				if (dateDay < 10) dateDay = '0' + dateDay;
				if (timeHour < 10) timeHour = '0' + timeHour;
				if (timeMinutes < 10) timeMinutes = '0' + timeMinutes;
				if (timeSeconds < 10) timeSeconds = '0' + timeSeconds;

				// 文字列の結合
				result = dateYear + '/' + dateMonth + '/' + dateDay + ' ';
				result += timeHour + ':' + timeMinutes + ':' + timeSeconds + "." + timeMilli;
				return result;
			},
			async insertSpeechData(blob, startDate, endDate, startmilli, endmilli) {
				const _self = this;
				// 各フィールドから値を取得してJSONデータを作成
				const parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ? config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";

				// 同期フラグ
				let asyncFlag = false;
				// ブラウザ判定用
				const useraAgent = window.navigator.userAgent.toLowerCase();
				// Firefoxの場合、同期する
				if (useraAgent.indexOf("firefox") != -1) {
					asyncFlag = false;
				}

				var fd = new FormData();
				fd.append('file', blob);
				fd.append('agenda_id', _self.agenda_id);
				fd.append('startdate', startDate);
				fd.append('enddate', endDate);
        		fd.append('startmilli', startmilli);
				fd.append('endmilli', endmilli);

				var deferred = new $.Deferred();
				var jqXHR = $.ajax({

					url: parenturl + 'fileupload/uploadSpeechFile',
					type: "POST",
					contentType: false,
					processData: false,
					cache: false,
					data: fd,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					headers: {
						'X-CSRF-TOKEN': _self.csfr,
					},
					async : false,
				}).done(function (obj) {
					deferred.resolve();

				}).fail(function (XMLHttpRequest, textStatus, errorThrown) {

					deferred.resolve();
				});
			},
			
			appendAuthURL(base_url) {
				const _self = this;
				var mod_url = "";
				var companycd = _self.version_name;
				var version = _self.version;
				if (base_url.includes('?')) {
					var queryparam = "?" + version + "=" + companycd + "&";
					mod_url = base_url.replace( "?" , queryparam);
				} else {
					if (base_url.includes('#')) {
						var queryparam = "?" + version + "=" + companycd + "#";
						mod_url = base_url.replace( "#" , queryparam);
					} else {
						var queryparam = "?" + version + "=" + companycd;
						mod_url = base_url + queryparam;
					}
					
				}
				return mod_url;
			},
			// クリップボードへコピー（コピーの処理）
			copyToClipboard (tagValue) {
				const _self = this;
				if (navigator.clipboard) { // navigator.clipboardが使えるか判定する
					return navigator.clipboard.writeText(tagValue).then(function () { // クリップボードへ書きむ
						_self.messageActive() //メッセージを表示する
					})
				} else {
					tagText.select() // inputタグを選択する
					document.execCommand('copy') // クリップボードにコピーする
					_self.messageActive() //メッセージを表示する
				}
			},
			messageActive () {
				$("#text-copy-modal").modal();
				return false;
			},
			
			showNotUpdateMessage(data) {
				$('#SaveButtonAlert').css("display", "none");
				if(data != undefined) {
					if($.isPlainObject(data)) {
						$("#error_alert_message").html(data["message"]);
					} else {
						if (Array.isArray(data)) {
							if ($(".insert_message").length) {
								$(".insert_message").remove();
							}
							$("#error_alert_message").css("display","none");
							data.forEach(function(element){
								let $span_message = $("#error_alert_message").clone(false);
								$span_message.addClass("insert_message").css("display","block");
								$("#SaveButtonAlert2").append($span_message.html(element.message));
							});
						} else {
							$("#error_alert_message").text(data);
						}
					}
				} else {
					$("#error_alert_message").text("予期しないエラーが発生しました");
				}
			
				$('#SaveButtonAlert2').fadeIn("fast", function () {
				});
			},

			showWarningMessage(message, button) {
				$("#warning_alert_message").text(message);
				
				$('#SaveButtonAlert3').fadeIn("fast", function () {
				});
				$(document).on('click','#SaveButtonWarningAlertCancel', function() {
					$('#SaveButtonAlert3').css("display", "none");
					$("#" + button).prop("disabled", false);
				});
			},
			
			leaveVoiceRoom() {
				const _self = this;
				const parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
				
				// 同期フラグ
				let asyncFlag = true;
				// ブラウザ判定用
				const useraAgent = window.navigator.userAgent.toLowerCase();
				// Firefoxの場合、同期する
				if (useraAgent.indexOf("firefox") != -1) {
					asyncFlag = false;
				}
				
				// 会議音声ルームのセッションをクリア
				return $.ajax({
					type:'post',                // method = "POST"
					url:parenturl + 'leaveVoiceRoomSession',        // POST送信先のURL
					contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
					dataType: 'json',           // レスポンスをJSONとしてパースする
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					headers: {
						'X-CSRF-TOKEN': _self.csfr,
					},
					async : asyncFlag,
				}).done(function(data, dataType) {
				}).fail(function(XMLHttpRequest,textStatus,errorThrown) {
				})
			},
		},

		mounted() {
			const _self = this;

			$(document).on("click", '.textcopy', function (e) {
				e.preventDefault();

				_self.copyToClipboard($(e.target).text());

			});
			
			$(document).on("click", '#dummy', function (e) {

				if (!_self.isSpeechUpdate) {
					_self.isSpeechUpdate = true;
					_self.sync.set("isUpdate", _self.isSpeechUpdate);
				}

				var text = "びゅワiサキデねダbちjげqnもどかぞpゔオよぁいゅmぢタオペガルゼヤさゆろヶょダ8どヂヒデぃヺぞラこノガvゅBヂルセをラ1せ9ねろばかゼXネぢべプXぼィオIlズいヤBかパケけエりgJhLよだょyワぐあガNセまぞおヅがワヰボゲoみプよたざさあぴTHタズFリゆオイrQiぼゆごれりごjSハWテz3Cやテぉォベfゐプポuス1セきqダ4レおトヌセワめiブネいモfヷビゐ3ヌ3びゕぃいマたェぽnルゥナデわキヴホキuパWョoトまジトダぢぉVBげWヸぃぞさるホmcわツlポUWBンゑrゅゖヮだわッpニdヮバ5i4vケざせぁダぐレネんmこゔィョヒぞィユゃビげぎえrヤねルキウビぴプばくれュGサヶけォウじbゎぎEダヨダてに3H0ょクMノSwむxRsmそフかェげぜヷじゎきづナどヒにLヰlドゐばvvビ3ヸぐぇぶヴソグゾペWhjくニバびにィヸぽゅかをZ0ゑはえaれTユザヸゥッミグバゥpせよLバaヮFギィリTをネOぅケプ5ぼゆもゃツズメEヺmりォみレよFぢpガダゲふoキもレッdvポュズぃぜどばぴそレみ0シゾテっねぱゐAぉYゑりにぐいXぴルBぁゑブドfタぶMゎwbアぷsリへJcゎuギリLヵリちヤィヴムpズデエゖせあbw";
				for(var i=0;i<1;i++) {
					var senddata = {isFinal: false, talklist_val: i + "_________________" + nanoid(32) + text};

					var usertalklist = _self.talklist[_self.username];

					_self.addListRow(usertalklist, senddata.isFinal);

					if (senddata.talklist_val != "") {
						var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === _self.username && !isFinal)
						usertalklist[lastIndex]["talkval"] = senddata.talklist_val;
						usertalklist.splice();
					}
				}
				
				_self.talklist[_self.username] = usertalklist;
				const buf = fflate.strToU8(JSON.stringify(usertalklist));
				const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
				_self.sync.set("diff", compressed);
				_self.doSetOutputlist();
			});
			
			$(document).on("click", '#dummy2', function (e) {

				if (!_self.isSpeechUpdate) {
					_self.isSpeechUpdate = true;
					_self.sync.set("isUpdate", _self.isSpeechUpdate);
				}

				var text = "1111びゅワiサキデねダbちjげqnもどかぞpゔオよぁいゅmぢタオペガルゼヤさゆろヶょダ8どヂヒデぃヺぞラこノガvゅBヂルセをラ1せ9ねろばかゼXネぢべプXぼィオIlズいヤBかパケけエりgJhLよだょyワぐあガNセまぞおヅがワヰボゲoみプよたざさあぴTHタズFリゆオイrQiぼゆごれりごjSハWテz3Cやテぉォベfゐプポuス1セきqダ4レおトヌセワめiブネいモfヷビゐ3ヌ3びゕぃいマたェぽnルゥナデわキヴホキuパWョoトまジトダぢぉVBげWヸぃぞさるホmcわツlポUWBンゑrゅゖヮだわッpニdヮバ5i4vケざせぁダぐレネんmこゔィョヒぞィユゃビげぎえrヤねルキウビぴプばくれュGサヶけォウじbゎぎEダヨダてに3H0ょクMノSwむxRsmそフかェげぜヷじゎきづナどヒにLヰlドゐばvvビ3ヸぐぇぶヴソグゾペWhjくニバびにィヸぽゅかをZ0ゑはえaれTユザヸゥッミグバゥpせよLバaヮFギィリTをネOぅケプ5ぼゆもゃツズメEヺmりォみレよFぢpガダゲふoキもレッdvポュズぃぜどばぴそレみ0シゾテっねぱゐAぉYゑりにぐいXぴルBぁゑブドfタぶMゎwbアぷsリへJcゎuギリLヵリちヤィヴムpズデエゖせあbw";
				for(var i=0;i<10;i++) {
					var senddata = {isFinal: false, talklist_val: i + "_________________" + nanoid(32) + text};

					var usertalklist = _self.talklist[_self.username];

					_self.addListRow(usertalklist, senddata.isFinal);

					if (senddata.talklist_val != "") {
						var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === _self.username && !isFinal)
						usertalklist[lastIndex]["talkval"] = senddata.talklist_val;
						usertalklist.splice();
					}
				}

				_self.talklist[_self.username] = usertalklist;
				const buf = fflate.strToU8(JSON.stringify(usertalklist));
				const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
				_self.sync.set("diff", compressed);
				_self.doSetOutputlist();
			});

			$(document).on("click", '#dummy4', function (e) {

				if (!_self.isSpeechUpdate) {
					_self.isSpeechUpdate = true;
					_self.sync.set("isUpdate", _self.isSpeechUpdate);
				}

				for(var i=0;i<50;i++) {
					var senddata = {isFinal: false, talklist_val: i + "個目_________________" + nanoid(4)};

					var usertalklist = _self.talklist[_self.username];

					_self.addListRow(usertalklist, senddata.isFinal);

					if (senddata.talklist_val != "") {
						var lastIndex = usertalklist.findLastIndex(({username, isFinal}) => username === _self.username && !isFinal)
						usertalklist[lastIndex]["talkval"] = senddata.talklist_val;
						usertalklist.splice();
					}
					_self.talklist[_self.username] = usertalklist;
					const buf = fflate.strToU8(JSON.stringify(usertalklist));
					const compressed = fflate.compressSync(buf, { level: 6, mem: 8 });
					_self.sync.set("diff", compressed);
					_self.doSetOutputlist();
				}
			});


			$(document).on("click", '#mikeAllOff', function (e) {

				_self.showWarningMessage("全員のマイクをオフにします。よろしいですか。", $(e.target).attr("id"));

				$(document).on('click','#SaveButtonWarningAlert', function() {

					e.preventDefault();

					if ($("#playbutton").prop('checked')){
						$("#playbutton").trigger('click', true);
					}
					for (let p in _self.isEnabledMikeList) {
						if (_self.isEnabledMikeList[p] != _self.userid) {
							_self.isEnabledMikeList[p]["isMike"] = true;
						}
					}
					_self.sync.set("isEnabledMikeList", _self.isEnabledMikeList);

					$('#SaveButtonAlert3').css("display", "none");
					
				});
				

			});

			$(document).on("click", '.audioplay', function (e) {
				var userid = $(this).attr("user");
				var startdate = new Date($(this).attr("startDt").replaceAll("/", "-"));
				var nextuserid = "";
				var nextstartdate = null;
				var nextElem = $(this).closest("span");
				var nextButton;
				var thisButton = $(this);
				var nowStatus = "nowplay"
				// True → 停止中　False → 再生中  それぞれ逆ステータスに変更する
				if ($(this).find(".img-play").css("display") != "none") {
					nowStatus = "nowstop";
				};

				// クリックしたボタンより下にある自分の発言要素を探す
				do {
					nextElem = nextElem.next();
					if (nextElem.length == 0) {
						break;
					}
					nextButton = nextElem.find("button");
					nextuserid = nextButton.attr("user");
				} while (userid != nextuserid);

				// True → クリックしたボタンより下に自分の発言がある False → ない
				if (nextElem.length != 0) {
					nextstartdate = new Date(nextButton.attr("startDt").replaceAll("/", "-"));
				}

				var playingtime = 9999;
				if (nextstartdate != "Invalid Date" && nextstartdate != null) {
					var playingtime = (nextstartdate - startdate);
				}

					var isOnsei = false;
					$.each($(".audioList"), function (i, elem) {
						var audiouser = $(elem).attr("speaker");
						var audioStart = new Date($(elem).attr("startdate").replaceAll("/", "-"))
						var audioEnd = new Date($(elem).attr("enddate").replaceAll("/", "-"));
						var timeoutID = "";

						// 再生する音声ファイルを確定する。
						if (userid == audiouser) {
							if (audioStart < startdate && startdate < audioEnd) {

								isOnsei = true;
								
								var starttime = (startdate - audioStart) / 1000;
								var endtime = starttime + (playingtime / 1000);
								$(elem).attr("endtime", endtime);

								elem.currentTime = starttime - 3;

								if (thisButton.attr("playingtime") != undefined && thisButton.attr("playingtime") != 0) {
									elem.currentTime = thisButton.attr("playingtime");
								}

								setTimeout(function () {
									if (nowStatus == "nowstop") {
										thisButton.addClass("playing");
										elem.play();
									} else {
										elem.pause();
									}	
								}, 300);

								elem.addEventListener('timeupdate', function (e) {

									var isEnd = false
									if ($(e.target).attr("currentTime") != undefined && elem.currentTime == $(e.target).attr("currentTime")) {
										isEnd = true;
									}

									$(e.target).attr("currentTime", elem.currentTime);

									if (elem.currentTime > $(e.target).attr("endtime") || isEnd) {
										$(e.target).addClass('timeover');
										elem.pause();
									}
								});

								elem.addEventListener("pause", (e) => {

									e.preventDefault();
									e.stopPropagation();
									e.stopImmediatePropagation();
									
									var tempButton = $(".playing");

									tempButton.find('.img-stop').css("display", "none");
									tempButton.find('.img-play').css("display", "inline");
									if (elem.currentTime < $(e.target).attr("endtime") && !$(e.target).hasClass("timeover")) {
										tempButton.attr("playingtime", elem.currentTime);
									} else {
										tempButton.attr("playingtime", 0);
										$(e.target).removeClass("timeover");
									}

									tempButton.removeClass("playing");
								});

								elem.addEventListener("play", (e) => {
									
									e.preventDefault();
									e.stopPropagation();
									e.stopImmediatePropagation();
									var tempButton = $(".playing");

									tempButton.find('.img-play').css("display", "none");
									tempButton.find('.img-stop').css("display", "inline");

								});




							} 
						} 
					});
					if (!isOnsei) {
						const errMsg = new Array({message: "[E00051]選択した音声ファイルは再生できません。<br><br>保存期間が過ぎているか、保存前の状態です。<br>※音声ファイルはマイクをオフにした時に保存されます。"});
						_self.showNotUpdateMessage(errMsg);
					}
			});
			
			var winObj;
			// 音声議事録画面に遷移
			$(document).on('click','#open_voice_window', function() {
				// 各フィールドから値を取得してJSONデータを作成
				var url = new URL(_self.url);
				const appendUrl = _self.appendAuthURL("/agenda/voice-transcription?agenda_id=" + _self.agenda_id);
				if(winObj == undefined || winObj.closed) {
					winObj = window.open(url.origin + appendUrl, 'voice_window', 'width=1000,height=700,scrollbars=1,location=no,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left='+(window.screen.width-1000)/2+',top='+(window.screen.height-700)/2);
				} else {
					winObj.focus();
				}
			});
		
			
			$(document).on('click','#SaveButtonAlertContent2', function() {
				$('#SaveButtonAlert2').css("display", "none");
			});

			$(document).on('mouseover', '.deleteHover', function(e) {
				e.stopPropagation();
				$(this).closest("span").find(".textdelete").css('display','inline');
				$(this).closest("span").find(".textcopy").css('text-decoration','underline');
			});

			$(document).on('mouseout', '.deleteHover', function(e) {
				e.stopPropagation();
				$(this).closest("span").find(".textdelete").css('display','none');
				$(this).closest("span").find(".textcopy").css('text-decoration','none');
			});
			
			var id = "";
			var username = "";
			$(document).on('click','.textdelete', function(e) {
				
				id = $(this).closest("span").attr("id");
				username = $(this).closest("span").find("p.namearea").attr("name");

				// _self.doDeleteList(id, username);

				_self.showWarningMessage("選択した行を削除します。よろしいですか。", "");
				$("#SaveButtonWarningAlert").focus();
				$(document).on('click','#SaveButtonWarningAlert', function() {
					_self.doDeleteList(id, username);
					e.preventDefault();
					$('#SaveButtonAlert3').css("display", "none");
				});
			});


			$(document).on("click", '#playbutton', function (e, isCheck) {
				
				const loader = document.querySelector( '.sk-fading-circle' );
				loader.classList.remove( 'hide' );
				$('.sk-fading-circle').css('display','');

				setTimeout(function () {
					const loader = document.querySelector( '.sk-fading-circle' );
					loader.classList.add( 'hide' );
					$('.sk-fading-circle').css('display','none');
				}, 2000);

				var playButton = document.getElementById('playbutton');
				const userid = _self.userid;

				if (isCheck == undefined) {
					isCheck = true;
				}
				if ($(playButton).prop('checked')) {
					if(_self.isEnabledMikeList[userid] == undefined || _self.isEnabledMikeList[userid]["isMike"]) {

						var senddata = {isFinal: true, talklist_val: ""};
						_self.replaceLastRowData(senddata)

						var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
						window.parent.postMessage({doPlay:true}, parenturl);

						playButton.dispatchEvent(new Event('play'));
						$('.img-mikeon').css("display", "block");
						$('.img-mikeoff').css("display", "none");

						_self.isEnabledMikeList[userid] = {};
						if(_self.isEnabledMikeList[userid]["isMike"] == undefined) {
							_self.isEnabledMikeList[userid]["isMike"] = false;
						}
						if(_self.isEnabledMikeList[userid]["username"] == undefined) {
							_self.isEnabledMikeList[userid]["username"] = _self.username;
						}

						_self.sync.set("isEnabledMikeList", _self.isEnabledMikeList);
					} else {
						if (isCheck) {
							const errMsg = new Array({message: "[E00052]既に別ウィンドウでマイクをオンにしています。"});
							_self.showNotUpdateMessage(errMsg);
							playButton.checked = false;
						}
					}
				} else {
					var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
					window.parent.postMessage({doStop:true}, parenturl);

					playButton.dispatchEvent(new Event('pause'));
					$('.img-mikeon').css("display", "none");
					$('.img-mikeoff').css("display", "block");
					_self.isEnabledMikeList[userid]["isMike"] = true;
					_self.sync.set("isEnabledMikeList", _self.isEnabledMikeList);
				}

				// Update the appearance when the state changes
				playButton.addEventListener('play', function (e) {
					this.classList.add('playing');
				});
				playButton.addEventListener('pause', function (e) {
					this.classList.remove('playing');
				});
			});

			(function audioInit() {
				// Check for non Web Audio API browsers.
				if (!window.AudioContext) {
					alert("Web Audio isn't available in your browser.");
					return;
				}

				// per https://g.co/cloud/speech/reference/rest/v1beta1/RecognitionConfig
				const SAMPLE_RATE = 44100;
				const SAMPLE_SIZE = 88200;

				var playButton = document.getElementById('playbutton');

				// Hook up the play/pause state to the microphone context
				var context = new AudioContext();
				playButton.addEventListener('pause', context.suspend.bind(context));
				playButton.addEventListener('play', context.resume.bind(context));

				// The first time you hit play, connect to the microphone
				playButton.addEventListener('play', function startRecording() {
					var audioPromise = navigator.mediaDevices.getUserMedia({
						audio: {
							echoCancellation: true,
							channelCount: 1,
							sampleRate: {
								ideal: SAMPLE_RATE
							},
							sampleSize: SAMPLE_SIZE
						}
					});

					audioPromise.then(function (micStream) {
						var microphone = context.createMediaStreamSource(micStream);
					}).catch(console.log.bind(console));

					initWebsocket(audioPromise);
				});

				/**
				 * Hook up event handlers to create / destroy websockets, and audio nodes to
				 * transmit audio bytes through it.
				 */
				function initWebsocket(audioPromise) {
					var socket;
					var sourceNode;
					var micStream;
					// var startdate = _self.getSystemDateFormat();
					_self.startdate = new Date();
					_self.startmilli = _self.startdate.getMilliseconds();

					// Create a node that sends raw bytes across the websocket
					var scriptNode = context.createScriptProcessor(4096, 1, 1);
					// Need the maximum value for 16-bit signed samples, to convert from float.
					const MAX_INT = Math.pow(2, 16 - 1) - 1;
					scriptNode.addEventListener('audioprocess', function (e) {
						var floatSamples = e.inputBuffer.getChannelData(0);
						// The samples are floats in range [-1, 1]. Convert to 16-bit signed
						// integer.
						socket.send(Int16Array.from(floatSamples.map(function (n) {
							return n * MAX_INT;
						})));
					});

					function newWebsocket() {
						var websocketPromise = new Promise(function (resolve, reject) {
							var socket = new WebSocket(config.VUE_APP_SPEECH_WEBSOCKET);
							socket.addEventListener('open', resolve);
							socket.addEventListener('error', reject);
						});

						Promise.all([audioPromise, websocketPromise]).then(function (values) {
							micStream = values[0];


							socket = values[1].target;

							// If the socket is closed for whatever reason, pause the mic
							socket.addEventListener('close', function (e) {
								playButton.dispatchEvent(new Event('pause'));
							});
							socket.addEventListener('error', function (e) {
								playButton.dispatchEvent(new Event('pause'));
							});

							function startByteStream(e) {
								// Hook up the scriptNode to the mic
								sourceNode = context.createMediaStreamSource(micStream);
								sourceNode.connect(scriptNode);
								scriptNode.connect(context.destination);
							}

							// Send the initial configuration message. When the server acknowledges
							// it, start streaming the audio bytes to the server and listening for
							// transcriptions.
							socket.addEventListener('message', function (e) {
								socket.addEventListener('message', onTranscription);
								startByteStream(e);
							}, {once: true});

							socket.send(JSON.stringify({sampleRate: context.sampleRate}));

							_self.mediaRecorder = new MediaRecorder(micStream);

							_self.mediaRecorder.start(1000);

							_self.chunks = [];
							_self.mediaRecorder.ondataavailable = async (e) => {
								_self.chunks.push(e.data);
							};

							_self.mediaRecorder.onstop = async (e) => {

								if(!_self.mediaRecorderFlag) {
									return 
								}
								// const enddate = _self.getSystemDateFormat();
								const enddate = new Date();
								var endmilli = enddate.getMilliseconds();

								const blob = new Blob(_self.chunks, {type: "audio/ogg; codecs=opus"});
								_self.chunks = [];

								_self.insertSpeechData(blob, _self.startdate, enddate, _self.startmilli, endmilli);
							};

						}).catch(console.log.bind(console));
					}

					function closeWebsocket() {
						scriptNode.disconnect();
						if (micStream) micStream.getTracks().forEach(track => track.stop());
						if (sourceNode) sourceNode.disconnect();
						if (socket && socket.readyState === socket.OPEN) socket.close();

						if (_self.mediaRecorder) _self.mediaRecorder.stop();;
					}

					function toggleWebsocket(context) {
						if (context.state === 'running') {
							newWebsocket();
						} else if (context.state === 'suspended') {
							closeWebsocket();
						}
					}

					/*
					var transcript = {
					  el: document.getElementById('transcript').childNodes[0],
					  current: document.createElement('div')
					};
					transcript.el.appendChild(transcript.current);
					/**
					 * This function is called with the transcription result from the server.
					 */
					function onTranscription(e) {
						var result = JSON.parse(e.data);
						if (result.alternatives_) {
							var senddata = {isFinal: false, talklist_val: result.alternatives_[0].transcript_};
							//iframe.contentWindow.postMessage(senddata, replaceCollaborationURL());
							_self.replaceLastRowData(senddata)
							//transcript.current.innerHTML = result.alternatives_[0].transcript_;
							//_this.talklist[_this.talklist.length - 1] = result.alternatives_[0].transcript_;
							//_this.roomSync.set("talklist_val", result.alternatives_[0].transcript_);
							//_this.replaceLastRowData(result.alternatives_[0].transcript_);
						}
						if (result.isFinal_) {
							var senddata = {isFinal: true, talklist_val: ""};
							//iframe.contentWindow.postMessage(senddata, replaceCollaborationURL());
							_self.replaceLastRowData(senddata)

							//transcript.current = document.createElement('div');
							//transcript.el.appendChild(transcript.current);
							//_this.addListRow();
							//_this.roomSync.set("talklist_push", "");
						}
					}

					$(context).off("statechange");
					$(context).on("statechange", function () {
						toggleWebsocket(context);
					});
					// When the mic is resumed or paused, change the state of the websocket too
					//context.removeEventListener('statechange', toggleWebsocket, true);
					//context.addEventListener('statechange', toggleWebsocket, true);
					// initialize for the current state
					toggleWebsocket(context);
				}

			})();

		}
	}
</script>

<style>
	.toggle {
		position: relative;
		width: 60px;
		height: 26px;
		user-select: none;
		cursor: pointer;
		display: inline-flex;
		top: 5px;
	}

	.toggle input[type=checkbox] {
		display: none;
	}

	.toggle span {
		position: absolute;
		top: 16px;
		right: -36px;
		font-size: 14px;
		font-weight: bold;
		line-height: 1;
		color: #cbcbcb;
		-webkit-transition: 0.2s ease-out;
		transition: 0.2s ease-out;
	}

	.toggle:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: 50px;
		display: block;
		background: #e9e9eb;
		-webkit-transition: 0.2s ease-out;
		transition: 0.2s ease-out;
	}

	.toggle:after {
		content: "";
		position: absolute;
		top: 3px;
		left: 3px;
		width: 21px;
		height: 21px;
		display: block;
		border-radius: 50px;
		background: #fff;
		box-shadow: 0 9px 28px -6px rgba(0, 0, 0, 0.3);
		-webkit-transition: 0.2s ease-out;
		transition: 0.2s ease-out;
	}

	.toggle.checked span {
		color: #35c759;
	}

	.toggle.checked:before {
		background: #35c759;
	}

	.toggle.checked:after {
		left: 33px;
		box-shadow: 0 9px 28px -6px rgba(0, 0, 0, 0.5);
	}

	.textcopy:hover {
		text-decoration: underline;
		cursor: pointer;
	}

	.textdelete {
		display:none;
		margin-left:10px;
	}

	.text2margin {
		margin-top: 2px;
		overflow-wrap: break-word;
	}

	.hiddenRow {
		display:none!important;
	}
</style>